module.exports = __webpack_public_path__ + "fa0f8c31e98a23858125af6a556bdc5e.MP3";